export default {
  document: {
    operationName: 'user',
    query: `query getDocumentsToVerify($limit: Int, $offset: Int) {
      user(where: {document_verifications: {document_status: {_eq: "pending"}}}, limit: $limit, offset: $offset) {
        email
        id
        document_verifications {
          file_name
          document_status
        }
        user_profiles {
          firstName
          lastName
        }
      }
      @@@@
    }
    `,
    aggregateQuery: `user_aggregate(where: {document_verifications: {document_status: {_eq: "pending"}}}, limit: $limit, offset: $offset) {
      aggregate{
        count
      }
    }`,
    columnTypes: {
      documentVerifications: 'images',
    },
    columns: {
      email: 'email',
      id: 'id',
      documentVerifications: 'document_verifications',
      firstName: 'user_profiles.0.firstName',
      lastName: 'user_profiles.0.lastName',
    },
  },
  payouts: {
    operationName: 'reservation',
    query: `query getPayouts($limit: Int, $offset: Int) {
      reservation(where: {reservationState: {_eq: "completed"}, _not: {_and: {transaction_histories: {payout_email: {_is_null: false}}, transactions: {_not: {payment_type: {_eq: "refund"}}}}}}, limit: $limit, offset: $offset) {
        id
        hostId
        checkIn
        checkOut
        hostPayouts {
          payEmail
          id
          isDefault
        }
        total
        transaction_histories {
          id
          user_id
        }
        reservationState
        hostServiceFee
        listing {
          title
        }
        userByHostId {
          user_profiles {
            firstName
            lastName
            profileId
          }
          email
        }
      }
      @@@@
    }
    
    `,
    aggregateQuery: `reservation_aggregate(where: {reservationState: {_eq: "completed"}, _not: {transaction_histories: {payout_email: {_is_null: false}}}}) {
      aggregate {
        count
      }
    }`,
    columns: {
      id: 'id',
      hostId: 'hostId',
      checkIn: 'checkIn',
      checkOut: 'checkOut',
      payEmail: 'hostPayouts.0.payEmail',
      total: 'total',
      reservationState: 'reservationState',
      hostServiceFee: 'hostServiceFee',
      title: 'listing.title',
      firstName: 'userByHostId.user_profiles.firstName',
      lastName: 'userByHostId.user_profiles.lastName',
      profileId: 'userByHostId.user_profiles.profileId',
      email: 'userByHostId.email',
    },
  },
};



// WEBPACK FOOTER //
// ./src/routes/siteadmin/pageableTable/PageableTables.js